let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d1fmr")).then(() => parcelRequire('gU6Me'));